import { Theme, Typography, withStyles, WithStyles } from '@material-ui/core'
import RemoveIcon from 'mdi-react/DeleteIcon'
import moment from 'moment-timezone'
import { FC } from 'react'
import { ApplicantAvailability } from '../../../types/applicantAvailability'

const styles = ({ breakpoints, spacing }: Theme) => ({
  card: {
    display: 'flex',
    padding: '0.5rem 1rem',
    backgroundColor: '#F1F2F4',
    marginBottom: '1rem',
    alignItems: 'center',
    borderRadius: '7px',
    justifyContent: 'space-between',
    'text-transform': 'capitalize',
    fontSize: '1rem'
  },
  info: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  timeContainer: {
    background: '#5C6DCE',
    color: '#ffffff',
    borderRadius: '7px',
    padding: '4px 8px'
  }
})

interface SuggestTimeCardProps extends WithStyles {
  availability: ApplicantAvailability
  removeAvailability?(arg: any): void
}

const SuggestTimeCard: FC<SuggestTimeCardProps> = ({
  availability,
  removeAvailability,
  classes
}: SuggestTimeCardProps) => {
  return (
    <div className={classes.card}>
      <div className={classes.info}>
        <Typography variant='body1'>{`${moment(availability.startDate).format(
          'dd D.M'
        )} - ${moment(availability.endDate).format(
          'dd D.M.YYYY'
        )}`}</Typography>
        <div className={classes.timeContainer}>
          <Typography variant='body2'>{`${moment(availability.startTime).format(
            'HH:mm'
          )} - ${moment(availability.endTime).format('HH:mm')}`}</Typography>
        </div>
      </div>

      {removeAvailability && (
        <div
          onClick={() =>
            removeAvailability(availability.applicantAvailabilityId)
          }
        >
          <RemoveIcon />
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(SuggestTimeCard)
